<div id="layout-wrapper" appDragScroll>
  <app-header [collapsed]="isCollapsed" (toggleSidebar)="onToggleSidebar()"></app-header>
  <app-navigation
    [collapsed]="isCollapsed"
    [isMobile]="isMobile"
    [drawerOpen]="drawerOpen"
    (toggle)="toggleNavigation($event)"
    (drawerClosed)="onDrawerClosed()"></app-navigation>
  <div class="main-content" [ngClass]="{ 'contenido-grande': isCollapsed }">
    <div class="container-fluid">
      <router-outlet></router-outlet>
    </div>
  </div>
  <app-softphone-widget *ngIf="showSoftphone"></app-softphone-widget>
</div>
